import { BlipCommandBaseRequest } from "../../../base/models/BlipCommandBaseRequest";

export class GetFileUrlRequest extends BlipCommandBaseRequest {
  constructor() {
    super("/upload-media-uri", "GET", "MEDIA");
  }
}
